import { useState } from "react";
import { Button } from "@common/index";
import { ComponentColor } from "@common/types";
import {
    VariantOptionsModal,
    type VariantSelection,
} from "@admin/Inventory/VariantOptions/VariantOptionsModal";

// Opens the Variant Options picker the way the product form will: it starts
// from the last picks and hands them back on Close.
export const VariantOptionsPicker = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selection, setSelection] = useState<VariantSelection>({});

    return (
        <div className="p-6 bg-white rounded-lg shadow-md max-w-4xl">
            <h2 className="text-xl font-bold mb-4">Variant Options picker</h2>

            <Button onClick={() => setIsOpen(true)} color={ComponentColor.Primary}>
                Open Variant Options
            </Button>

            <p className="mt-4 text-sm">Picks (option id → value id):</p>
            <pre aria-label="Picks" className="bg-gray-50 p-4 rounded text-left">
                {JSON.stringify(selection)}
            </pre>

            {isOpen && (
                <VariantOptionsModal
                    initialSelection={selection}
                    onClose={(picks) => {
                        setSelection(picks);
                        setIsOpen(false);
                    }}
                />
            )}
        </div>
    );
};
